var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoStadim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "771px",
    height: "247px",
    viewBox: "0 0 771 247",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-stadim2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-stadim2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.81,129.89 C90.34,129.17 59.56,128.21 51.16,129.32 C43.05,130.39 36.55,134.78 37.54,142.32 C38.34,148.41 42.05,149.69 68.21,153.61 C104.31,159.17 114.55,167.55 117.75,191.89 C121.64,221.43 104.81,241.33 73.23,245.49 C58.75,247.4 29.71,246.21 11.62,245.36 L13.81,213.22 C26.65,214.48 61.81,215.15 68.19,214.31 C76,213.31 81.85,208.38 80.82,200.56 C79.98,194.19 74.38,191.98 47.68,188.42 C15.59,184.1 3.52,173 0.47,149.84 C-3.39,120.58 17.15,102 46.7,98.07 C58.29,96.55 86.7,97.23 103.56,97.95 L102.81,129.89 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.52,129.15 L121.52,129.15 L121.52,98.76 L141.39,97.59 L146.67,69.23 L178.2,63.11 L178.2,97.3 L216.81,97.3 L216.81,129.15 L178.21,129.15 L178.21,199.86 C178.21,207.17 182.6,212.43 189.91,212.43 C193.41,212.43 211.82,211.26 215.62,210.67 L218.25,239 C208.9,241 189.61,244.26 180.84,244.26 C159.22,244.26 140.52,229.35 140.52,207.73 L140.52,129.15 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.05,108.4 C243.96,103.4 276.68,94.67 290.71,94.67 C329.57,94.67 347.98,111.67 347.98,150.48 L347.98,204.54 C348.56,211.84 353.82,238.73 353.82,238.73 L321.97,244.57 C319.34,240.48 314.38,231.42 313.21,226.16 L312.62,226.16 C300.62,235.8 280.48,244.28 264.12,244.28 C239.86,244.28 224.67,221.19 224.67,197.82 C224.67,169.76 250.67,159.54 279.02,155.45 C284.87,154.57 306.19,152.53 310.29,152.53 L310.29,146.39 C310.29,130.9 301.23,126.81 286.62,126.81 C277.27,126.81 245.71,135.58 237.23,138.21 L229.05,108.4 Z M310.58,197.23 L310.58,180 C304.44,180 288.37,180.88 283.69,181.76 C272.59,183.76 262.69,185.85 262.69,196.36 C262.69,203.67 267.08,213.02 274.69,213.02 C285.16,213 302.1,204.83 310.58,197.23 L310.58,197.23 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.81,240.77 L455.81,240.77 L454.35,231.42 C444.71,237.26 431.85,244.28 419.58,244.28 C379.25,244.28 361.72,219.73 361.72,169.18 C361.72,118.63 383.33,94.67 422.81,94.67 C434.21,94.67 453.2,100.51 453.2,100.51 L453.2,49.31 L490.81,42.07 L490.81,240.77 Z M453.12,200.77 L453.12,132.07 C453.12,132.07 437.63,126.81 428.87,126.81 C406.08,126.81 399.94,140.81 399.94,169.18 C399.94,198.11 405.49,210.970134 423.61,210.970134 C430.66,211 444.98,206 453.16,200.74 L453.12,200.77 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "544.02 240.77 506.33 240.77 506.33 104.39 544.02 97.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.91,108.7 C607.42,102.85 624.91,94.7 637.23,94.7 C653.59,94.7 662.07,101.13 671.71,111.06 C683.98,104.34 705.9,94.7 720.8,94.7 C752.07,94.7 770.18,121 770.18,152.56 L770.18,240.8 L732.49,240.8 L732.49,154.6 C732.49,142.04 725.18,128.3 712.62,128.3 C704.14,128.3 689.24,134.44 682.82,137.94 L684.57,154.6 L684.57,240.8 L646.87,240.8 L646.87,154.6 C646.87,142.04 638.98,128.3 626.42,128.3 C618.53,128.3 604.51,134.44 598.95,137.94 L598.95,240.77 L561.26,240.77 L561.26,103.9 L596.32,97.3 L596.91,108.7 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.01,38.2 C503.633932,31.5284997 501.373383,18.5538052 507.940767,9.10451719 C514.508151,-0.344770788 527.457048,-2.74869337 536.9784,3.71377074 C546.499751,10.1762349 549.046754,23.09775 542.69,32.69 L513.01,38.2 Z",
    id: "Path",
    fill: "#C22228"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStadim);
export default __webpack_public_path__ + "static/media/logo-stadim.c23036ee6baaf49d7f142b709e62211d.svg";
export { ForwardRef as ReactComponent };